module.exports = __webpack_public_path__ + "img/icon_home_lian.4976bd7b.png";